import ReactGA from 'react-ga4';
import config from './config';

// Extend window object to include gtag
declare global {
	interface Window {
		gtag: (...args: any[]) => void;
	}
}

/** gtag checks `ga-disable-<measurement id>` before every hit, so nothing is sent while it is set. */
export const setGA4Enabled = (enabled: boolean) => {
	(window as unknown as Record<string, boolean>)[`ga-disable-${config.ga4MeasurementId}`] = !enabled;
};

// GA4 stays off until a route opts in via `ContentWrapper`'s `analyticsPage`.
setGA4Enabled(false);

// Initialize GA4 with default consent state (denied)
export const initializeGA4 = (measurementId: string) => {
	// Initialize GA4 with default consent state
	ReactGA.gtag('consent', 'default', {
		'ad_storage': 'denied',
		'analytics_storage': 'denied',
		'functionality_storage': 'denied',
		'personalization_storage': 'denied',
		'security_storage': 'granted' // Always granted
	});
	ReactGA.initialize(measurementId, {
		gtagOptions: {
			// Must be boolean — the string 'false' is truthy and does not disable auto page_view.
			send_page_view: false,
			// Default would be document.title on any automatic page_view; keep title out of GA4.
			page_title: '',
		},
	});
};

// Update GA4 consent state
export const updateGA4Consent = (consent: boolean) => {
	ReactGA.gtag('consent', 'update', {
		'ad_storage': consent ? 'granted' : 'denied',
		'analytics_storage': consent ? 'granted' : 'denied',
		'functionality_storage': consent ? 'granted' : 'denied',
		'personalization_storage': consent ? 'granted' : 'denied',
		'security_storage': 'granted' // Always granted
	});
};

// Wrapper for ReactGA.event - no need to check consent as gtag handles it
export const trackGAEvent = (eventData: Parameters<typeof ReactGA.event>[0]) => {
	ReactGA.event(eventData);
};

// Wrapper for ReactGA.send - no need to check consent as gtag handles it
export const trackGAPageview = (pageData: Parameters<typeof ReactGA.send>[0]) => {
	ReactGA.send(pageData);
};
